import { FilterOption } from '@/components/Filter/types';
import ContentItem from '@/modules/corporate/modules/path/views/PathEditor/components/ContentItem';
import { ContentEntity } from '@/types/schema';

export type ContentMenuItem = ContentEntity & FilterOption;

export const getContentFilterOption = (content: ContentEntity): ContentMenuItem => {
  return {
    ...content,
    value: content.id,
    label: content.name,
  };
};

export const renderContentItem = ({ option }: { option: FilterOption }) => {
  return (
    <ContentItem
      className="cursor-pointer truncate rounded-8 px-12 py-4 hover:bg-bg-hover"
      content={option as ContentMenuItem}
    />
  );
};
